const courses = [
  {
    title: 'Database System Internals',
    number: 'CSE 444',
    link: 'https://courses.cs.washington.edu/courses/cse444/20sp/',
  },
  {
    title: 'Distributed Systems',
    number: 'CSE 452',
    link: 'https://courses.cs.washington.edu/courses/cse452/21sp/',
  },
  {
    title: 'Advanced Relational Database Management Systems',
    number: 'IMT 563',
  },
  {
    title: 'Machine Learning',
    number: 'IMT 574',
  },
  {
    title: 'Server-side Development',
    number: 'INFO 441',
  },
  {
    title: 'Client-Side Development',
    number: 'IMT 549',
  },
  {
    title: 'Algorithms And Computational Complexity',
    number: 'CSE 417',
    link: 'https://courses.cs.washington.edu/courses/cse417/20wi/',
  },
  {
    title: 'Core Java Programming',
    number: 'CSE40480',
    link: 'https://extension.ucsd.edu/courses-and-programs/java-programming-ii-core-java-programming',
  },
];

export default courses;
